module.exports = __webpack_public_path__ + "img/cart3.16b33ab1.svg";